/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, KeyboardAvoidingView } from 'react-native';

import { buttonRounded } from '@/assets/styles/buttonStyles';
import Colors from '@global/colors';
import { isWeb, isIos } from '@global/screens';

import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import ModalTopRounded from '@components/modal/ModalTopRounded';
import ItemDetail from '@components/global/ItemDetail';
import PropTypes from 'prop-types';

const propTypes = {
  show: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
};

const ModalViewLoyalty = (props) => {
  const { show, data, onClose, onEdit } = props;

  return (
    <KeyboardAvoidingView behavior={isIos ? 'padding' : undefined}>
      <ModalTopRounded
        visible={show}
        fullPage={isWeb ? true : false}
        animationType={isWeb ? 'fade' : 'slide'}
        onClose={() => onClose()}
        title="Loyalty Point Rule">
        {data && (
          <View style={{ width: '100%', paddingHorizontal: 16 }}>
            <ItemDetail name="Name" value={data.name} />
            <ItemDetail name="Last Updated" value={data.last_updated} />
            <ItemDetail name="Priority" value={data.priority.toString()} />
            <ItemDetail
              name="Status"
              nameStyle={{ alignSelf: 'center' }}
              value={data.status}
              valueStyle={{ ...data.statusStyle, width: 'auto' }}
            />
            <Button
              buttonStyle={{
                ...buttonRounded,
                width: '100%',
                backgroundColor: Colors.white,
                borderColor: Colors.grey0,
                marginTop: 30,
              }}
              title={
                <SociollaText
                  style={{
                    fontSize: 14,
                    letterSpacing: 0.5,
                    color: Colors.black,
                    width: '100%',
                    textAlign: 'center',
                  }}>
                  Edit
                </SociollaText>
              }
              onPress={() => onEdit(data._id)}
            />
          </View>
        )}
      </ModalTopRounded>
    </KeyboardAvoidingView>
  );
};

// const styles = StyleSheet.create({});
ModalViewLoyalty.propTypes = propTypes;

export default ModalViewLoyalty;
